import { Routes } from '@angular/router';
import { MainpageComponent } from './layouts/mainpage/mainpage.component';
import { authGuard } from './core/auth/auth.guard';
import { guestGuard } from './core/auth/guest.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
     canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'signup',
     canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/signup/signup.component').then(
        (m) => m.SignupComponent,
      ),
  },
  {
    path: 'forgot',
    loadComponent: () =>
      import('./features/auth/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'login_with_mobile',
     canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login-with-mobile/login-with-mobile.component').then(
        (m) => m.LoginWithMobileComponent,
      ),
  },

  {
    path: '',
    component: MainpageComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
        data: { breadcrumb: 'Dashboard' },
      },

      {
        path: 'master',
        loadChildren: () =>
          import('./features/master/master.routes').then((r) => r.MASTER_ROUTE),
        //  data: { breadcrumb: 'Master' }
      },
      {
        path: 'kyc',
        loadChildren: () =>
          import('./features/kyc/kyc/kyc.routes').then((r) => r.KYC_ROUTE),
        //  data: { breadcrumb: 'KYC Profile' }
      },
      {
        path: 'billing',
        loadChildren: () =>
          import('./features/recharge/recharge.routes').then(
            (r) => r.RECHARGE_ROUTE,
          ),
        //  data: { breadcrumb: 'Billing' }
      },
      {
        path: 'rate-calculator',
        loadChildren: () =>
          import('./features/rate-calculator/rate-calculator.routes').then(
            (r) => r.RATECALCULATOR_ROUTE,
          ),
        //  data: { breadcrumb: 'Rate Calculator' }
      },
      {
        path: 'warehouse',
        loadChildren: () =>
          import('./features/warehouse/warehouse.routes').then(
            (r) => r.WAREHOUSE_ROUTE,
          ),
        //  data: { breadcrumb: 'Warehouse' }
      },
      {
        path: 'my-order',
        loadChildren: () =>
          import('./features/my-order/my-order.routes').then(
            (r) => r.ORDER_ROUTES,
          ),
        //  data: { breadcrumb: 'Order List' }
      },
      {
        path: 'setting',
        loadChildren: () =>
          import('./features/setting/setting.routes').then(
            (r) => r.SETTING_ROUTE,
          ),
        //  data: { breadcrumb: 'Setting' }
      },
      {
        path: 'spot-rate',
        loadChildren: () =>
          import('./features/spot-rate/spot-rate.routes').then(
            (r) => r.SPOT_RATE_ROUTES,
          ),
        //  data: { breadcrumb: 'Spot Rate' }
      },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
